import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { toPascalCase } from '@cli-utils/text.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { formLabel } from '@next-adapter/generators/form/form-shared/form-label.js'
import { labelWithDescription } from '@next-adapter/generators/form/form-shared/label-with-description.js'
import { renderCreatableSelectFieldActionButtonsTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-creatable-select-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderCreatableSelectField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const fieldPascal = toPascalCase(field.name)
  const optionsVar = `${field.name}Options`
  const openVar = `${field.name}Open`
  const setOpenVar = `set${fieldPascal}Open`
  const searchVar = `${field.name}Search`
  const setSearchVar = `set${fieldPascal}Search`
  const pendingVar = `create${fieldPascal}OptionPending`
  const createHandler = `handleCreate${fieldPascal}Option`
  const placeholder = field.placeholder || `Select ${label.toLowerCase()}`
  const lowerLabel = label.toLowerCase()
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)

  return renderCreatableSelectFieldActionButtonsTemplate({
    indent: indent,
    fieldName: field.name,
    optionsVar: optionsVar,
    searchVar: searchVar,
    formItemProps: formItemProps(field),
    labelWithDescription: labelWithDescription(
      formLabel(field, label),
      hintJSX,
      `${indent}        `
    ),
    openVar: openVar,
    setOpenVar: setOpenVar,
    stringify: JSON.stringify(placeholder),
    lowerLabel: lowerLabel,
    setSearchVar: setSearchVar,
    defaultValueFromHandlerContent: defaultValueFromHandler
      ? `${indent}                        ${defaultValueFromHandler}(option.value)\n`
      : '',
    pendingVar: pendingVar,
    createHandler: createHandler
  })
}
